const lMS = [
  {
    title: 'LMS',
    icon: 'DatabaseIcon',
    enableFeature: true,
    children: [
      {
        title: 'PFI Onboarding',
        enableFeature: true,
        children: [
          {
            title: 'PFI Application',
            route: 'pfi-application',
            hasPermission: 'VIEW_PFI_ONBOARDING',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'PFIs',
        route: 'pfi-onboarding-list',
        hasPermission: 'VIEW_PFI_ONBOARDING',
        enableFeature: true,
      },
      {
        title: 'PFI Lending',
        enableFeature: true,
        children: [
          {
            title: 'Loan Application',
            route: 'loan-application-list',
            hasPermission: 'VIEW_EXTERNAL_LOAN_ACCOUNT',
            enableFeature: true,
          },
          {
            title: 'Collateral Management',
            route: 'collateral-management',
            hasPermission: 'VIEW_COLLATERAL_INFORMATION',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'End Beneficiary Mgt.',
        enableFeature: true,
        children: [
          {
            title: 'Batch Upload & Validation',
            route: 'batch-upload-validation',
            hasPermission: 'BATCH_END_BENEFICIARY_UPLOAD',
            enableFeature: true,
          },
          {
            title: 'Failed End Beneficiaries',
            route: 'failed-beneficiaries',
            hasPermission: 'MODIFY_END_BENEFICIARY_UPLOAD',
            enableFeature: true,
          },
          {
            title: 'Successful End Beneficiaries',
            route: 'successful-beneficiaries',
            hasPermission: 'VIEW_END_BENEFICIARY',
            enableFeature: true,
          },
        ],
      },
    ],
  },
]

export default lMS
